// import changeCase from 'change-case';
import queryString from 'query-string';

export interface IParams {
    [index: string]: string;
}

export const stringify = (params: IParams) => {
    return Object.keys(params)
        .map(key => `${key}=${encodeURIComponent(params[key])}`)
        .join('&');
};

export const parse = (locationSearch: string): { [key: string]: string } => {
    // const
    const params = queryString.parse(locationSearch);

    return Object.keys(params).reduce((reducer, key: string) => {
        return {
            ...reducer,
            [key]: params[key],
        };
    }, {});
};

export default {
    parse,
    stringify,
};
